import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetAttatchments,
  DeleteAttatchment,
  UploadAttatchmentFile,
  UploadAttatchment,
  UpdateAttatchmentFile,
  UpdateAttatchment,
  DownloadFile,
  GetDropdownList,
};

function GetAttatchments(contractNumber, versionNumber, editionNumber, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/documents`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UploadAttatchmentFile(formData, onSuccess, onError) {
  var headers = getAuthHeader();
  headers.headers["Content-Type"] = "multipart/form-data";

  axios
    .post(process.env.VUE_APP_BASE_API_URL + `/tempfiles`, formData, headers)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UploadAttatchment(contractNumber, versionNumber, editionNumber, attatchmentObject, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/documents`,
      attatchmentObject,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdateAttatchmentFile(
  contractNumber,
  versionNumber,
  editionNumber,
  documentId,
  contentId,
  fileId,
  formData,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  headers.headers["Content-Type"] = "multipart/form-data";

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/documents/${documentId}/contents/${contentId}/files/${fileId}`,
      formData,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdateAttatchment(
  contractNumber,
  versionNumber,
  editionNumber,
  documentId,
  attatchmentObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/documents/${documentId}`,
      attatchmentObject,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteAttatchment(contractNumber, versionNumber, editionNumber, documentId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/documents/${documentId}`,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}

function DownloadFile(contractNumber, versionNumber, editionNumber, documentId, contentId, onSuccess, onError) {
  var headers = getAuthHeader();
  headers.responseType = "blob";

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/documents/${documentId}/contents/${contentId}`,
      headers
    )
    .then((response) => {
      var disposition = response.headers["content-disposition"];

      var filename = "file.pdf";

      if (disposition && disposition.indexOf("attachment") !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      onSuccess(response.data, filename);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetDropdownList(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/infrastructure/dropdownlist/filelinkusedfor`, headers)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
